import type { PropsWithChildren } from "react";

import { Typography } from "antd";

import { getEnvironmentValues } from "@/config/environment";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

const { Link } = Typography;

const ApiDocLink = ({ children }: PropsWithChildren) => {
  const { apiDocumentationUrl } = getEnvironmentValues();
  const showApiDocumentationLink = useFeatureFlag("showApiDocumentationLink");

  // `apiDocumentationUrl` is set in all the environments by default, so we
  // still need to check for showApiDocumentationLink feature flag
  if (!apiDocumentationUrl || !showApiDocumentationLink) return children;

  return (
    <Link href={apiDocumentationUrl} underline target="_blank">
      {children}
    </Link>
  );
};

export default ApiDocLink;
